<template>
  <v-form v-model="valid" v-if="!loadingCaseForms" class="ph16">
    <v-flex md12>
      <v-flex pb-3>
        Please check and sign in the space provided to acknowledge that our funeral director has explained our funeral packages adequately, provided you with a quotation and gone through the preparation list. In addition, you confirmed that you fully understand and agree with the terms and conditions stated above. By signing below, you have confirmed that you have given consent to Direct Funeral Services Pte Ltd on the collection, use and disclosure of my personal data for administrative and marketing purposes.
      </v-flex>
      <v-flex>
        <v-radio-group class="required large-radio"
                       large
                       label="I confirm that I have checked and verified that there are no valuable items on the deceased body at the point of collection."
                       v-model="localAgreementFormData.no_valuable_items"
        >
          <v-radio
            :label="'Yes'"
            :value="1"
          ></v-radio>
          <v-radio
            :label="'No'"
            :value="0"
          ></v-radio>
        </v-radio-group>
        <v-text-field
          v-if="localAgreementFormData.no_valuable_items === 0"
          label="If there are, please declare"
          v-model="localAgreementFormData.valuable_items_declaration"
        ></v-text-field>
      </v-flex>
      <v-flex>
        <v-radio-group class="required large-radio"
                       label="I confirm that I have checked and verified that there are none of any medical implants (pace maker and others) or any prosthetics (dentures, prosthetic limbs, gold teeth) are in the deceased body at the point of collection."
                       v-model="localAgreementFormData.no_additional_items_on_body"
        >
          <v-radio
            :label="'Yes'"
            :value="1"
          ></v-radio>
          <v-radio
            :label="'No'"
            :value="0"
          ></v-radio>
        </v-radio-group>
      <v-text-field
        v-if="localAgreementFormData.no_additional_items_on_body === 0"
        label="If there are, please declare"
        v-model="localAgreementFormData.valuable_additional_items_declaration"
      ></v-text-field>
      </v-flex>
      <v-flex>Ash placement will be arranged by:</v-flex>
      <v-flex>
        <v-radio-group v-model="localAgreementFormData.ash_placement_arranged_by" class="large-radio">
          <v-radio label="N/A" value="0"></v-radio>
          <v-radio label="Family" value="1"></v-radio>
          <v-radio label="Direct Funeral Services Pte Ltd" value="2"></v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex>Ash Collection Location:</v-flex>
      <v-flex>
        <v-text-field
          v-model="localAgreementFormData.ash_collection_location"
        />
      </v-flex>
      <v-flex>Ash Collection Vendor:</v-flex>
      <v-flex>
        <v-text-field
          v-model="localAgreementFormData.ash_collection_vendor"
        />
      </v-flex>
    </v-flex>
  </v-form>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        formData: 'getOnBoardClientFormAnswers',
        editable: 'isOnBoardClientFormAnswersEditable',
        loadingCaseForms: 'getLoadingFormsStatus'
      })
    },
    data () {
      return {
        localAgreementFormData: [],
        valid: false,
        valuableItemsDeclarationRules: [
          v => !this.localAgreementFormData.no_valuable_items ? !!v || 'Required' : true
        ],
        valuableAdditionalItemsDeclarationRules: [
          v => !this.localAgreementFormData.no_additional_items_on_body ? !!v || 'Required' : true
        ]
        // noValuableItemsRules: [
        //   v => (!this.localAgreementFormData.valuable_items_declaration || this.localAgreementFormData.valuable_items_declaration === '') ? !!v || 'Required' : true
        // ],
        // noAdditionalItemsOnBodyRules: [
        //   v => (!this.localAgreementFormData.valuable_items_declaration || this.localAgreementFormData.valuable_additional_items_declaration === '') ? !!v || 'Required' : true
        // ],
        // ashPlacementArrangedByRules: [
        //  v => !!v || 'Required'
        // ]
      }
    },
    methods: {
      valuableItemsComplete (checklist) {
        return checklist.no_valuable_items === true || (typeof checklist.valuableItemsDeclaration !== 'undefined' && checklist.valuableItemsDeclaration !== null)
      },
      valuableAdditionalItemsComplete (checklist) {
        return checklist.no_additional_items_on_body === true || (typeof checklist.valuableAdditionalItemsDeclaration !== 'undefined' && checklist.valuableAdditionalItemsDeclaration !== null)
      },
      ashesPlacementComplete (checklist) {
        return checklist.ashesPlacementAgreement === true && checklist.ashPlacementArrangedBy > 0
      },
      checkListComplete (checklist) {
        return this.ashesPlacementComplete(checklist) && this.valuableItemsComplete(checklist) && this.valuableAdditionalItemsComplete(checklist)
      }
    },
    watch: {
      valid (status) {
        this.$store.commit('updateAgreementOnBoardForm', this.localAgreementFormData)
        this.$emit('valid:changed', status)
      },
      formData () {
        this.caseSelected = this.caseid
        this.localAgreementFormData = this.formData.agreement_form_data
      },
      localAgreementFormData: {
        handler (newObject) {
          this.$emit('agreement:status', this.checkListComplete(newObject), newObject)
        },
        deep: true
      }
    },
    created () {
      this.localAgreementFormData = this.formData.agreement_form_data
    }
  }
</script>

<style>
  .large-radio .v-input--selection-controls__input i {
    font-size: 30px !important;
  }
  .v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
    margin: 10px 0 20px 0 !important;
  }
  .large-radio .v-radio .v-input--selection-controls__input {
    height: 35px !important;
  }
  .large-radio label {
    left: 5px !important;
  }
  .ph16 {
    padding-left: 16px;
    padding-right: 16px;
  }
</style>



// WEBPACK FOOTER //
// DfsServiceAgreementCheckList.vue?cef7eefe